import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { useState } from 'react'
import { MdModeEdit } from 'react-icons/md'
import { RxDragHandleDots2 } from 'react-icons/rx'

import { ConfirmDeleteModal } from '../../modals/ConfirmDeleteModal.tsx'
import { EditIconModal } from '../../modals/EditIconModal.tsx'
import { SocialMediaToggle } from '../SocialMediaToggle'
import { iconMapping } from '../../helpers/iconMapping'

export const SocialIcon = ({
  id,
  name,
  link,
  enabled: initialEnabled,
  setSocialMediaIcons,
}: SocialMedia) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const Icon = iconMapping[name]

  const handleEdit = () => {
    setShowEditModal(true)
  }

  const handleDelete = () => {
    setShowEditModal(false)
    setShowDeleteModal(true)
  }

  const confirmDelete = () => {
    setShowDeleteModal(false)
  }

  return (
    <div
      className="flex items-center justify-between rounded-lg p-4 shadow-normal"
      style={style}
    >
      <div className="flex items-center gap-3.5">
        <div ref={setNodeRef} {...listeners} {...attributes}>
          <RxDragHandleDots2 color="#c2c2c2" className="mr-1.5 cursor-grab" />
        </div>

        {Icon ? <Icon size={24} /> : null}

        <span className="text-sm">{name}</span>
      </div>

      <div className="flex items-center gap-3.5">
        <MdModeEdit
          color="#c2c2c2"
          className="cursor-pointer"
          onClick={handleEdit}
        />

        <EditIconModal
          onClose={() => setShowEditModal(false)}
          onConfirm={() => setShowEditModal(false)}
          onDelete={handleDelete}
          showModal={showEditModal}
          name={name}
          link={link}
          id={id}
        />

        <SocialMediaToggle id={String(id)} initialEnabled={initialEnabled} />

        <ConfirmDeleteModal
          setSocialMediaIcons={setSocialMediaIcons}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={confirmDelete}
          showModal={showDeleteModal}
          id={id}
        />
      </div>
    </div>
  )
}
